import React from 'react';
import { SVGProps } from './type';

export const IconBank = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M7.26316 11.0263H5.36842V17.6579H7.26316V11.0263ZM12.9474 11.0263H11.0526V17.6579H12.9474V11.0263ZM21 19.5526H3V21.4474H21V19.5526ZM18.6316 11.0263H16.7368V17.6579H18.6316V11.0263ZM12 4.64105L16.9358 7.23684H7.06421L12 4.64105ZM12 2.5L3 7.23684V9.13158H21V7.23684L12 2.5Z"
      fill={fill}
    />
  </g>
);
